import {
  ChartBar,
  ChartLine,
  ChartPie,
  ChartSingleStat,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import type { VisualizationResult } from "../types";
import { useAskAIVisualizationLogic } from "./useAskAIVisualizationLogic";

export interface AskAIVisualizationProps {
  visualization: VisualizationResult;
}

export const AskAIVisualization = ({ visualization }: AskAIVisualizationProps) => {
  const { t } = useTranslation("ai");
  const { chartData, formatCellValue } = useAskAIVisualizationLogic(visualization);

  if (!chartData) return null;

  switch (chartData.type) {
    case "single-stat":
      return <ChartSingleStat value={chartData.value} label={chartData.label ?? t("(No value)")} />;
    case "pie-chart":
      return <ChartPie data={chartData.data} height={300} />;
    case "bar-chart":
      return (
        <ChartBar
          data={chartData.data}
          categoryKey={chartData.categoryKey}
          dataKey={chartData.dataKey}
          additionalDataKeys={chartData.additionalDataKeys}
          height={300}
        />
      );
    case "time-series":
      return <ChartLine data={chartData.data} xAxisKey={chartData.xAxisKey} lines={chartData.lines} height={300} />;
    case "table":
      return (
        <div className="rounded-md border max-h-96 overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                {chartData.columns.map((col) => (
                  <TableHead key={col}>{col}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {chartData.data.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {chartData.columns.map((col) => (
                    <TableCell key={col}>{formatCellValue(row[col])}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
  }
};
